<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党员教育</el-breadcrumb-item>
				<el-breadcrumb-item>在线考试</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input 
								style="width: 200px;margin-right: 10px;"
								v-model="getdata.title" 
								size="small"
								placeholder="输入名称查询"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select v-model="getdata.difficulty" 
								size="small"
								style="width: 100px !important;margin-right: 10px;" 
								clearable placeholder="试题难度"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									label="简单"
									value="1">
								</el-option>
								<el-option
									label="适中"
									value="2">
								</el-option>
								<el-option
									label="困难"
									value="3">
								</el-option>
							</el-select>
							<el-select v-model="getdata.type" 
								style="width: 100px !important;" 
								size="small"
								clearable placeholder="试题类型"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									label="单选"
									value="1">
								</el-option>
								<el-option
									label="多选"
									value="2">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" @click="$router.push({path:'/add_tg',query:{id:$route.query.id,type:'add',class_id:$route.query.id}})">新建题干</el-button>
							<el-button type="primary" size="small" @click="$router.go(-1)">返回</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { xxjy,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import myTables from '@/components/tables/tables.vue'
	import DelData from '@/components/delToast.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					id: this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					title: "",
					class_id:this.$route.query.id,
					difficulty: "",
					type:"",
					page: 1
				},
				delList:[],
				showlocal:false,
				tableData:[],
				totalPage:0,
				studyNum:0,
				studyTime:0,
				tableHeader: [     // 表头
					{prop: 'title', label: '试题题干',width:''},
					{prop: 'difficulty', label: '难度',formatData: function (val) {
						if(val == 1){
							return '简单'
						}else if(val == 2){
							return '适中'
						}else if(val == 3){
							return '困难'
						}
					}},
					{prop: 'establish', label: '创建人',width:'80'},
					{prop: 'addtime', label: '创建时间',width:"110",formatData: function (val) {
						return  that.$changeTime(val)
					}},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '120',align:'center',
						oper: [
							{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''},
						]
					}
				]
			}
		},
		components:{Page,DelData,myTables},
		created(){that = this},
		mounted() {
			that.dataList();
		},
		methods:{
			// 数据
			dataList(){
				xxjy.questionList(that.getdata).then(res => {
					if(res.data.pagedata!=null){
						if(res.data.pagedata.length>0){
							that.tableData = res.data.pagedata;
							that.totalPage = res.data.count;
						}else{
							that.tableData = [];
							that.totalPage = 0;
						}
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			open(item){
				xxjy.openQuestionClass({
					id:item.id,
					open:!item.open
				}).then(res => {
					if(res.code == 200){
						
						Message.success(res.msg)
					}else{
						Message.error(res.msg)
					}
				})
			},
			// 详情
			showDetail(data){
				that.$router.push({
					path:'/dyxx_detail',
					query:{
						flag:data.flag,
						uid:that.getdata.id,
						cy_zz:data.cy_zz,
						id:data.id
					},
				})
			},
			
			// 一键删除
			selectList(value){
				that.delList =value;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						xxjy.delQuestion({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 编辑
			edit(data){
				this.$router.push({
					path:'/add_tg',
					query:{
						id:data.id,
						class_id:this.$route.query.id,
						type:'edit',
						dwid:data.dwid,
						flag:data.flag,
					},
				})
			},
			// 导出表格
			daochu(){
				dwgl.exportPartyOrgan(that.getdata);
			}
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian{
			width: 100px;
			height: 60px;
			object-fit: cover;
		}
		.zttit{
			font-size: 16px;
			font-weight: bold;
		}
		.textCount{
			font-size: 14px;
		}
		.intro{
			font-size: 14px;
		}
	}
</style>

